import api from "./api";

const OptionsService = {
  getAgenciaOptions: function (query) {
    return api.get("acordo/options/agencia/?q=" + (query || ""));
  },
  getCooperadoOptions: function (query) {
    return api.get("acordo/options/cooperado/?q=" + (query || ""));
  },
  getSingularOptions: function (query) {
    return api.get("acordo/options/singular/?q=" + (query || ""));
  },
  getTipoCobrancaOptions: function (query) {
    return api.get("acordo/options/tipo-cobranca/?q=" + (query || ""));
  },
  getTipoAcordoOptions: function (query) {
    return api.get("acordo/options/tipo-acordo/?q=" + (query || ""));
  },
  getFormaPagamentoOptions: function (query) {
    return api.get("acordo/options/forma-pagamento/?q=" + (query || ""));
  },
  getStatusConciliadoOptions: function (query) {
    return api.get("acordo/options/status-conciliado/?q=" + (query || ""));
  },
  getStatusParcelaOptions: function (query) {
    return api.get("acordo/options/status-parcela/?q=" + (query || ""));
  },
  getOperadorOptions: function (query) {
    return api.get("acordo/options/operador/?q=" + (query || ""));
  },
};

export default OptionsService;



// WEBPACK FOOTER //
// ./src/services/OptionsService.js